<template>
    <modal name="shareCollaborationModal" width="598px" height="auto" :scrollable="true" @before-open="collaborations = []" @opened="getCollaborations()">
        <div class="modal-content">
            <div class="d-flex flex-column align-items-center mt-2">
                <inline-svg src="/assets/img/icons/share-team-tile.svg"></inline-svg>
                <div class="dashboard-card-title mt-3">Share with Team Members to Collaborate</div>
                <span class="dashboard-card-description ps-3 pe-3">
                    Select or remove the Team Members you want to share this Card Deck with.
                </span>
            </div>
            <div class="modal-body d-flex flex-column align-items-center">
                <div style="width: 100%;" :class="{'loading' : loading.data}">
<!--                    <div class="mb-2">-->
<!--                        <user-select user_type="caregiver" :search-by-email="true" @change="addUser"/>-->
<!--                    </div>-->
                    <div class="d-flex flex-row justify-content-left align-items-center mb-2" v-for="collaboration in collaborations">
                        <form-checkbox v-model="collaboration.assigned" class="me-1"></form-checkbox>
                        <div class="flex-1">
                           <user-avatar :user="collaboration.caregiver" :subtitle="collaboration.role" :displayName="true"></user-avatar>
                        </div>
<!--                        <btn-group-toggle :disabled="!collaboration.assigned" :options="[-->
<!--                                {'label': 'Can View', 'value': 'viewer', 'icon': '/assets/img/icons/eye.svg'},-->
<!--                                {'label': 'Can Edit', 'value': 'editor', 'icon': '/assets/img/icons/edit-04.svg'}-->
<!--                            ]"-->
<!--                          v-model="collaboration.role">-->
<!--                        </btn-group-toggle>-->
                    </div>
                </div>
            </div>
            <div class="divider mb-1"></div>
            <div class="modal-footer justify-content-center">
                <btn class="btn-outline-light flex-1" @click="$modal.hide('shareCollaborationModal', {cardDeck: cardDeck})">Cancel</btn>
                <btn class="btn btn-primary flex-1" :loading="loading.save" @click="saveCollaborations">Save</btn>
            </div>
        </div>
    </modal>
</template>

<script>
import UserAvatar from "@/components/UserAvatar.vue";
import FormCheckbox from "@/components/core/FormCheckbox.vue";
import UserSelect from "@/components/UserSelect.vue";
import BtnGroupToggle from "@/components/core/BtnGroupToggle.vue";

export default {
    name: "CardDeckShareCollaboration",
    components: {BtnGroupToggle, UserSelect, UserAvatar, FormCheckbox },
    props: ['cardDeck'],
    data() {
        return {
            loading: {
                data: false,
                save: false,
            },
            collaborations: [],
        };
    },
    // watch: {
    //     cardDeck(val) {
    //         this.collaborations = [];
    //         if (val) {
    //             this.getCollaborations();
    //         }
    //     },
    // },
    methods: {
        getCollaborations() {
            this.collaborations = [];
            this.loading.data = true;
            this.$http.post('/deck/collaborations/members', { deck_id: this.cardDeck.id})
                .then(function (res) {
                    this.loading.data = false;
                    this.collaborations = res.data.data
                }).catch(() => {
                this.loading.data = false;
            });
        },
        saveCollaborations() {
            this.loading.save = true;
            this.$http.post('/deck/collaborations/save', { deck_id: this.cardDeck.id, collaborations: this.collaborations })
                .then(function (res) {
                    this.loading.save = false;
                    this.$events.$emit('loadMyCardDecks');
                    this.$modal.hide('shareCollaborationModal')
                    this.$modal.show('cardDeckCollaborationsConfirmationModal');
                    // this.$gtag.event('card_deck_shared', {
                    //   deck_id: this.cardDeck.id,
                    //   heroes: heroes,
                    // });
                }).catch(() => {
                this.loading.save = false;
            });
        },
        addUser(user) {
            if (this.collaborations.find((collaboration) => collaboration.caregiver.id === user.id)) {
                return;
            }
            this.collaborations.push({
                caregiver: user,
                assigned: true,
                role: 'viewer'
            });
        },
    }
}
</script>

<style scoped>

</style>
